import {SocketLobbySend} from './SocketLobbySend'
import {RoomAction} from '@colonist/lobby-types'

export class SocketChat {
    static sendRoomChat(value: string) {
        SocketLobbySend.sendRoom(RoomAction.RoomChatSubmit, value)
    }
}
